import React from 'react';
import { UserOutlined, TeamOutlined, SettingOutlined, ProfileOutlined, ShopOutlined, SolutionOutlined } from '@ant-design/icons';
import StoreMapping from '../views/store-mapping/index.jsx';
import ServiceGoods from '../views/service-goods/index.jsx';
import StaffManage from '../views/staff-manage/index.jsx';
import StoreBusinessSetting from "../views/store-business-setting/index.jsx";
import ReservationData from '../views/reservation-data/index.jsx';
import RoleManage from '../views/role-manage/index.jsx';
import AccountManage from '../views/account-manage/index.jsx';
import StoreInventory from '../views/store-inventory/index.jsx';

const routes = [
  {
    path: '/layout/store-mapping',
    label: '门店映射',
    icon: <ShopOutlined />,
    element: <StoreMapping/>
  },
  {
    path: '/layout/service-goods',
    label: '美团服务管理',
    icon: <SolutionOutlined />,
    element: <ServiceGoods/>
  },
  {
    path: '/layout/staff-manage',
    label: '技师服务管理',
    icon: <TeamOutlined/>,
    element: <StaffManage/>
  },
  {
    path: '/layout/store-business-setting',
    label: '门店营业设置',
    icon: <SettingOutlined />,
    element: <StoreBusinessSetting/>
  },
  {
    path: '/layout/reservation-data',
    label: '美团预约数据',
    icon: <ProfileOutlined />,
    element: <ReservationData/>
  },
  {
    path: '/layout/role-manage',
    label: '角色权限管理',
    icon: <UserOutlined/>,
    element: <RoleManage/>
  },
  {
    path: '/layout/account-manage',
    label: '账户管理',
    icon: <TeamOutlined/>,
    element: <AccountManage/>
  },
  {
    path: '/layout/store-inventory',
    label: '非打通门店库存',
    icon: <SettingOutlined />,
    element: <StoreInventory />
  }
];

export default routes;
